var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9579 12.0417H27.944C27.5222 8.3015 24.8869 1.28974 15.9579 0V12.0417Z",
    fill: "#c59d48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5419 1.53418C5.5979 1.93374 0.0559692 7.72123 0.0559692 14.778C0.0559692 22.0799 5.96767 28.0001 13.2472 28.0001C20.2708 28.0001 26.0203 22.5139 26.4166 15.4579H12.5419V1.53418Z",
    fill: "#c59d48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramAgent);
export default __webpack_public_path__ + "static/media/diagramAgent.c6a2c13ad7db5bd335558bf2bbafa9ec.svg";
export { ForwardRef as ReactComponent };